module.exports = __webpack_public_path__ + "img/telehealth_home-visit.df98df31.svg";